<template>
  <div class="status-change-procedure-batch">
    <AppScrollbar style="height: 100%">
      <div class="batch-main">
        <div class="header">
          <div class="title">根据异动类型，下载相应的表格模板</div>
          <div class="check">
            <div class="label">选择学籍异动类型：</div>
            <el-radio-group v-model="changeType">
              <el-radio v-for="change in changes"
                        :key="change.code"
                        :label="change.code">{{change.name}}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="body">
          <keep-alive>
            <component :is="getComponent"
                       @dataImportSuccess="handleImportSuccess"></component>
          </keep-alive>
        </div>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import StatusChangeProcedureBatchDormancy from './dormancy'
import StatusChangeProcedureBatchSuspend from './suspend'
import StatusChangeProcedureBatchDropout from './dropout'
import StatusChangeProcedureBatchRollClass from './roll-class'
import StatusChangeProcedureBatchRollState from './roll-state'
import changeType from '../../../../../../../../constants/biz/status/changeType'
export default {
  name: 'StatusChangeProcedureBatch',
  components: {
    AppScrollbar
  },
  data () {
    return {
      changes: [
        changeType.DORMANCY,
        changeType.SUSPEND,
        changeType.DROPOUT,
        changeType.ROLL_CLASS,
        changeType.ROLL_STATE
      ],
      changeType: ''
    }
  },
  computed: {
    getComponent () {
      switch (this.changeType) {
        case changeType.DORMANCY.code:
          return StatusChangeProcedureBatchDormancy
        case changeType.SUSPEND.code:
          return StatusChangeProcedureBatchSuspend
        case changeType.DROPOUT.code:
          return StatusChangeProcedureBatchDropout
        case changeType.ROLL_CLASS.code:
          return StatusChangeProcedureBatchRollClass
        case changeType.ROLL_STATE.code:
          return StatusChangeProcedureBatchRollState
      }
    }
  },
  methods: {
    handleImportSuccess () {
      this.$emit('reloadGridData')
    }
  },
  created () {
    this.changeType = this.changes[0].code
  }
}
</script>

<style lang="scss">
  .status-change-procedure-batch {
    height: 100%;
    .batch-main {
      margin: auto;
      width: 600px;
      max-width: 100%;
      padding: 30px 15px;
      box-sizing: border-box;
      & > .header {
        & > .title {
          font-size: 13px;
        }
        & > .check {
          margin-top: 15px;
          font-size: 12px;
          display: flex;
          align-items: baseline;
          .el-radio-group {
            .el-radio {
              & > .el-radio__label {
                padding-left: 8px;
                font-size: 12px;
              }
            }
          }
        }
        & > .roll-class-tips {
          & > .label {
            color: #606266;
            font-size: 12px;
            font-weight: bold;
            margin-top: 12px;
            margin-bottom: 12px;
          }
          & > ul {
            list-style: none;
            margin: 0;
            padding: 0;
            & > li {
              color: #606266;
              font-size: 12px;
              & + li {
                margin-top: 4px;
              }
            }
          }
          & > .setup {
            .el-checkbox {
              .el-checkbox__label {
                font-size: 12px;
              }
            }
            .tip-msg {
              margin-top: 4px;
              color: #909399;
              font-size: 12px;
            }
          }
        }
      }
      & > .body {
        margin-top: 25px;
      }
    }
  }
</style>
